import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface DeletionImpactRow { entityType: string; count: number; amount?: number; currency?: string; }
export interface DeletionBlocker { kind: string; description: string; referenceId?: number; }
export interface ProjectDeletionPreview {
  projectId: number; projectName: string; projectCode?: string;
  impact: DeletionImpactRow[]; blockers: DeletionBlocker[]; canDelete: boolean;
}
export interface ProjectDeletionItem {
  id: number; phase: string; entityType: string; plannedCount: number; affectedRows: number;
  status: string; startedAt?: string; finishedAt?: string; durationMs?: number; error?: string;
}
export interface ProjectDeletionBatch {
  id: string; projectId: number; projectName: string; status: string;
  startedAt: string; finishedAt?: string; totalSteps: number;
  successCount: number; failedCount: number; skippedCount: number;
  blockReason?: string; items: ProjectDeletionItem[];
}

@Injectable({ providedIn: 'root' })
export class ProjectDeletionService {
  private base = `${environment.apiUrl}/ProjectDeletion`;
  constructor(private http: HttpClient) {}
  preview(projectId: number): Observable<ProjectDeletionPreview> { return this.http.get<ProjectDeletionPreview>(`${this.base}/preview/${projectId}`); }
  start(projectId: number, confirmationName: string): Observable<{ batchId: string }> { return this.http.post<{ batchId: string }>(`${this.base}/start/${projectId}`, { confirmationName }); }
  getBatch(batchId: string): Observable<ProjectDeletionBatch> { return this.http.get<ProjectDeletionBatch>(`${this.base}/batch/${batchId}`); }
  cancel(batchId: string): Observable<any> { return this.http.post(`${this.base}/batch/${batchId}/cancel`, {}); }
}
